import React, { useEffect, useState } from 'react';
import './Major_Blues.css'


import logo from './images/logo.png';

import { BrowserRouter, Link, Routes, Route } from "react-router-dom";

import tick from './images/tick.png';
import bg_img from './images/bg-img.png'
import up_icon1 from './images/up_icon.png';
import up_icon2 from './images/down_icon.png';

import '../Components/assets/style.css';
import Piano from './Piano';

import tune from '../Components/assets/tunes/correct-answer.mp3';

import './CustomAlert.css'

const Major_Blues = () => {


    const [currentNoteIndices, setCurrentNoteIndices] = useState(Array(7).fill(0));
    const notes = ['A', 'A#', 'Bb', 'B', 'C', 'C#', 'Db', 'D', 'D#', 'Eb', 'E', 'F', 'F#', 'Gb', 'G', 'G#', 'Ab'];
    const [answer, setAnswer] = useState(Array(7).fill('A')); // Initialize answer array with A alphabet

    const number_array = [1, 2, 'b3', 3, 5, 6, 1];


    const [showAlert, setShowAlert] = useState(false);

    const [right_answer, setRightAnswer] = useState([]);

    const [showVideo, setShowVideo] = useState(false);



    const major_scales_keys = ['C', 'G', 'D', 'A', 'E', 'B', 'F', 'Bb', 'Eb', 'Ab', 'Db']
    const u_tube_video = {
        1: ['https://www.youtube.com/embed/whkcCPk3WBY'],
        2: ['https://www.youtube.com/embed/O0R0AN-cKco'],
        3: ['https://www.youtube.com/embed/I6BtnWO_4hk'],
        4: ['https://www.youtube.com/embed/bU5LS57MXoE'],
        5: ['https://www.youtube.com/embed/SvjiV3esdhs'],
        6: ['https://www.youtube.com/embed/PAwyK34cDJE'],
        7: ['https://www.youtube.com/embed/51X6JqgiGJ4'],
        8: ['https://www.youtube.com/embed/OQaklcHIh4Y'],
        9: ['https://www.youtube.com/embed/4_GKbI59Srg'],
        10: ['https://www.youtube.com/embed/exy4EKY6cu4'],
        11: ['https://www.youtube.com/embed/i7mgPycLDKg']
    };
    let selectedVideo = '';



    function video_selection() {
        const matchIndex = major_scales_keys.findIndex(item => item === right_answer[0]);

        if (matchIndex !== -1) {
            selectedVideo = u_tube_video[matchIndex + 1] || '';
        } else {

            console.log('No matching item found');
        }
    }




    const handleNoteChange = (step, boxIndex) => {
        setCurrentNoteIndices(prevIndices => {
            const newIndices = [...prevIndices];
            newIndices[boxIndex] = (newIndices[boxIndex] + step + notes.length) % notes.length;
            const noteText = notes[newIndices[boxIndex]];

            // Update the answer array with the note text at the corresponding index
            setAnswer(prevAnswer => {
                const newAnswer = [...prevAnswer];
                newAnswer[boxIndex] = noteText;
                return newAnswer;
            });
            return newIndices;
        });
    };



    useEffect(() => {

        for (const boxIndex in correct_answer) {
            const correctAnswer = correct_answer[boxIndex];

            if (arraysAreEqual(answer, correctAnswer)) {

                const audio = new Audio(tune);
                audio.play();

                setRightAnswer([...correctAnswer])

                setShowAlert(true);
                setTimeout(() => {
                    setShowAlert(false);
                }, 5000);

                setShowVideo(true);

                break;

            } else {
                setShowVideo(false);
                setRightAnswer(null);
            }
        }
    }, [answer]);

    const arraysAreEqual = (arr1, arr2) => {
        if (arr1.length !== arr2.length) {
            return false;
        }

        for (let i = 0; i < arr1.length; i++) {
            if (arr1[i] !== arr2[i]) {
                return false;
            }
        }

        return true;
    };


    const correct_answer = {
        1: ['C', 'D', 'Eb', 'E', 'G', 'A', 'C'],
        2: ['G', 'A', 'Bb', 'B', 'D', 'E', 'G'],
        3: ['D', 'E', 'F', 'F#', 'A', 'B', 'D'],
        4: ['A', 'B', 'C', 'C#', 'E', 'F#', 'A'],
        5: ['E', 'F#', 'G', 'G#', 'B', 'C#', 'E'],
        6: ['E', 'F#', 'G', 'G#', 'B', 'C#', 'E'],
        7: ['F', 'G', 'Ab', 'A', 'C', 'D', 'F'],
        8: ['Bb', 'C', 'Db', 'D', 'F', 'G', 'Bb'],
        9: ['Eb', 'F', 'Gb', 'G', 'Bb', 'C', 'Eb'],
        10: ['Ab', 'Bb', 'B', 'C', 'Eb', 'F', 'Ab'],
        11: ['Db', 'Eb', 'E', 'F', 'Ab', 'Bb', 'Db'],
    }

    return (

        <div className="homePage-bg_major_pentatonic">

            {/* navbar code */}
            <div >
                <div className='cont0_navbar'>
                    <div className='cont1_navbar'>
                        <img src={logo} className='logo' />
                        <a href='#' className='nav_bar_txt'>Musical Scales Games</a>
                    </div>

                    <div className='cont2_navbar'>
                        <a href="#" className='nav_btns' >
                            <Link to="/" style={{ color: 'white', textDecoration: 'none' }} >
                                Major Scales
                            </Link>
                        </a>
                        <a href="#" className='nav_btns' >
                            <Link to="/major-pentatonic" style={{ color: 'white', textDecoration: 'none' }}>
                                Major Pentatonic
                            </Link>
                        </a>
                        <a href="#" className='nav_btns' >
                            <Link to="/major-blues" style={{ color: 'white', textDecoration: 'none' }}>
                                Major Blues
                            </Link>
                        </a>
                    </div>
                    <div className='cont3_navbar'>
                        <a href="#" className='nav_btns' >
                            <Link to="/minor-scales" style={{ color: 'white', textDecoration: 'none' }}>
                                Minor Scales
                            </Link>
                        </a>
                        <a href="#" className='nav_btns' >

                            <Link to="/minor-pentatonic" style={{ color: 'white', textDecoration: 'none' }}>
                                Minor Pentatonic
                            </Link>
                        </a>
                        <a href="#" className='nav_btns' >
                            <Link to="/minor-blues" style={{ color: 'white', textDecoration: 'none' }}>
                                Minor Blues
                            </Link>
                        </a>
                    </div>
                    
                </div>
            </div>
            {/* navbar code */}


            <div className='s1_cont_major_blues'>
                <h3 className='heading' >Major Blues Scales</h3>
                <div className='cont0'>
                    <img src={bg_img} className='bg-img' />
                </div>

                <div className='homeBtns'>
                    <h3 className='heading_majorscales' >
                        Use Arrows to change Notes
                    </h3>
                    <div class="text-container0">

                        {currentNoteIndices.map((currentNoteIndex, boxIndex) => (
                            <div className="text-container1" key={boxIndex}>
                                <a href="#" className="up_arrow_btn" onClick={(e) => { e.preventDefault(); handleNoteChange(1, boxIndex); }}>
                                    <img src={up_icon1} className="arrow_img" alt="Up Arrow" />
                                </a>
                                <p className="txt_cont">{notes[currentNoteIndex]}</p>
                                <a href="#" className="up_arrow_btn" onClick={(e) => { e.preventDefault(); handleNoteChange(-1, boxIndex); }}>
                                    <img src={up_icon2} className="arrow_img" alt="Down Arrow" />
                                </a>

                            </div>
                        ))}


                        {showAlert && (
                            <div className="custom-alert">
                                <img src={tick} className='tick-icon' />
                                <p className="alert-text">Correct Answer</p>
                            </div>
                        )}

                    </div>

                    <div className="text-container01">
                        {number_array.map((number, index) => (
                            <span className="text-container001" clas key={index}>{number}</span>
                        ))}
                    </div>



                    <div>
                        <h3 className='heading' >
                            Piano
                        </h3>
                        <div>
                            <Piano correctAnswer={right_answer} />
                        </div>
                    </div>




                    {showVideo ? (
                        <div>
                            {video_selection()}
                            <div>
                                <h3 style={{ textAlign: 'center', marginTop: '10px', fontSize: '25px', color: 'white' }}>Related Video</h3>
                                <div className='video'>
                                    <iframe
                                        title="My Video"
                                        width="800"
                                        height="160"
                                        style={{ borderRadius: '10px' }}
                                        src={selectedVideo}
                                        frameBorder="0"
                                        allowFullScreen
                                    ></iframe>
                                </div>
                            </div>
                        </div>) : null
                    }
                </div>
            </div>

        </div>

    );
};

export default Major_Blues;